import { IMlReview } from '../../types/newbuilding/reviews';
import { IApplicationState } from '../../types/redux';

export const getMlReviews = (state: IApplicationState): IMlReview | null => {
  return state.newbuilding.reviews?.mlReview || null;
};
